import React, { useEffect, useState } from "react";
import { AccountsListElement } from "@/features/home/components/accounts-list-element";
import { Dropdown, DropdownOption } from "@/shared/components/dropdown/base-dropdown";
import {
  useAccountGroupsContext,
  AccountGroups,
  Accounts,
} from "@/features/accounts/account-group/contexts/account-groups-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useTradeJumpContext } from "@/features/trade-jump/contexts/trade-jump-context";
import { useAccountPollingContext } from "@/features/accounts/shared/contexts/account-polling-context";

type AccountsListProps = {
  accountGroups: AccountGroups[];
  accounts: Accounts[];
  isOwner: boolean;
  onListSelect: (groupId: string) => void;
  onSelectElement: () => void;
};

export const AccountsList = ({
  accountGroups,
  accounts,
  isOwner,
  onListSelect,
  onSelectElement,
}: AccountsListProps) => {
  const { userSelectedAccountGroupId, setSelectedAccount } = useAccountGroupsContext();
  const { setOpenHomeModal } = useModalContext();
  const { setAuthType } = useInstitutionsContext();
  const { syncJump } = useTradeJumpContext();
  const { pollingInfos } = useAccountPollingContext();

  const [dropdownDefault, setDropdownDefault] = useState<DropdownOption | undefined>(undefined);
  useEffect(() => {
    const setDropdown = () => {
      let defaultValue = accountGroups.filter(
        (g) => g.accountGroupId === userSelectedAccountGroupId,
      );
      if (defaultValue.length === 0) {
        defaultValue = accountGroups.filter((g) => g.isSelected);
      }
      setDropdownDefault(
        defaultValue.map((group) => ({
          value: group.accountGroupId,
          label: group.accountGroupsName,
        }))[0],
      );
    };
    setDropdown();
  }, [accountGroups]);

  return (
    <>
      {/* ヘッダー */}
      <h2>
        <div className="form-select btn-group">
          <Dropdown
            options={accountGroups.map((group) => ({
              value: group.accountGroupId,
              label: group.accountGroupsName,
            }))}
            value={dropdownDefault}
            onChange={(selectedId) => {
              onListSelect(selectedId.toString());
            }}
            {...(!syncJump && { addNewLastLabel: "＋グループを追加" })}
            className="dropdown-group"
            data-tooltip={dropdownDefault?.label || ""}
          />
        </div>
      </h2>
      <div id="groupContainer" className="groups" role="region" aria-live="polite">
        {/* リスト */}
        <ul className="group active" data-view="group">
          {accounts.map((item, index) => {
            const isPolling = pollingInfos.some(
              (info) =>
                info.mlinkAccountId === item.mlinkAccountId &&
                info.mlinkId === item.mlinkId &&
                info.passbookType === item.passbookType,
            );
            return (
              <AccountsListElement
                key={`${item.mlinkAccountId}-${item.mlinkId}`}
                index={index.toString()}
                passbookType={item.passbookType}
                passbookName={item.passbookName}
                authorizationStatus={item.authorizationStatus}
                balance={item.balance} // 暫定値
                maintenance={item.isUnderMaintenance}
                ocrProcessStatus={item.ocrProcessStatus}
                isAggPolling={isPolling}
                isOwner={isOwner}
                syncJump={syncJump}
                onClick={() => {
                  setSelectedAccount(item);
                  onSelectElement();
                }}
                onReauth={() => {
                  setSelectedAccount(item);
                  if (item.industryCode === "01") {
                    setAuthType("bank");
                  } else if (item.industryCode === "03" && item.scrapeType === 3) {
                    setAuthType("crecaLookApi");
                  } else if (item.industryCode === "03") {
                    if (item.companyCode === "19659" || item.companyCode === "19660") {
                      setAuthType("crecaApi");
                    } else {
                      setAuthType("");
                    }
                  } else if (item.industryCode === "10" && item.scrapeType === 3) {
                    setAuthType("emoneyLookApi");
                  } else {
                    setAuthType("");
                  }
                  setOpenHomeModal("SiteReauth");
                }}
              />
            );
          })}
        </ul>
      </div>
    </>
  );
};
